
































import { defineComponent, ref, watch } from '@vue/composition-api'
import CloseButton from './CloseButton.vue'
import Editor from './Editor.vue'

export default defineComponent({
  name: 'DialogEditor',
  components: {
    CloseButton,
    Editor,
  },
  props: {
    visible: Boolean,
    content: String,
    shopLink: Boolean
  },
  setup(props, { emit }) {
    const editorContent = ref(props.content as string)

    watch(
      () => props.visible,
      (newVal: boolean) => {
        editorContent.value = newVal ? props.content : ''
      }
    )
    watch(
      () => props.content,
      (newVal: string) => {
        editorContent.value = newVal
      }
    )

    const save = () => {
      emit('save', editorContent.value)
    }

    return { editorContent, save }
  },
})
